import { useTheme } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

type CustomDayProps = PickersDayProps<DateTime> & {
  hasWorkout?: boolean;
};

export function CustomDay(props: CustomDayProps) {
  const { day, outsideCurrentMonth, hasWorkout, ...other } = props;
  const {
    palette: {
      primary,
      products: { performance },
    },
  } = useTheme();
  const isToday = day.hasSame(DateTime.now(), 'day') && !outsideCurrentMonth;

  return (
    <div className="relative flex flex-col items-center">
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        selected={false}
        sx={{
          cursor: 'pointer',
          '&.Mui-selected': {
            backgroundColor: 'transparent',
            color: 'inherit',
          },
          '&.MuiPickersDay-today': {
            border: 'none',
          },
          ...(isToday && {
            backgroundColor: primary.main,
            color: primary.contrastText,
          }),
        }}
      />
      {/* Workout indicator dot */}
      {hasWorkout && !outsideCurrentMonth && (
        <div
          className="absolute bottom-0.5 w-1 h-1 rounded-full"
          style={{ backgroundColor: performance.primary }}
        />
      )}
    </div>
  );
}
